<template>
  <page :title="$tc('magazines.revenue')">
    <div slot="page-header-right">
      <div style="display: flex; align-items: center;">
<!--        <a class="button mr-2" target="_blank">Export</a>-->
<!--        <month-options @submit="time => replace(time)" @calculate="calculate">-->
<!--          <span class="ml-2">{{ dateRange }}</span>-->
<!--        </month-options>-->
      </div>
    </div>
    <div class="box">

      <div class="level mb-4">
        <div class="level-left">
          Appstore
          <b-switch
            class="ml-2"
            passive-type='is-dark'
            type='is-info'
            :value="$route.query.payment == 'android'"
            @input="value => replaceQuery('payment', value ? 'playstore' : 'appstore')"
          >Playstore</b-switch>
        </div>

        <div v-if="incomes.response" class="level-right">

        </div>
      </div>

      <div class="card-content is-paddingless">
        <b-table
          :data="incomes.data"
          :loading="incomes.loading"
          paginated
          backend-pagination
          pagination-simple
          :current-page="incomes.current_page"
          :per-page="incomes.per_page"
          :total="incomes.total"
          @page-change="page => incomes.changePage(page)"
          backend-sorting
          @sort="(field, direction) => incomes.sort(field, direction)"
          :default-sort="['id', 'desc']"
          class="is-middle"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column field="id" label="#" sortable>
              {{ props.row.id }}
            </b-table-column>

            <b-table-column field="currency" label="Currency">
              {{ props.row.currency }}
            </b-table-column>

            <b-table-column field="Price" label="Price">
              {{ props.row.price }}
            </b-table-column>

            <b-table-column field="revenue" label="Revenue">
              {{ props.row.revenue }}
            </b-table-column>

            <b-table-column field="quantity" label="Quantity">
              {{ props.row.quantity }}
            </b-table-column>

            <b-table-column field="total" label="Total">
              {{ props.row.total }}
            </b-table-column>

            <b-table-column field="sale_of_return" label="Transaction Type">
              {{ props.row.sale_of_return }}
            </b-table-column>

            <b-table-column label="Country">
              <country-flag
                :country-code="props.row.country"
              ></country-flag>
            </b-table-column>

            <b-table-column field="transaction_date" label="Transaction Date" sortable>
              <b-tooltip :label="props.row.transaction_date | dateTime">
               {{ props.row.transaction_date | date }}
              </b-tooltip>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>{{$tc('Nothinghere')}}</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </div>
  </page>
</template>

<script>
// import MonthOptions from "@/components/MonthOptions";
import InteractsWithQueryString from "@/core/InteractsWithQueryString";
import CountryFlag from "@/components/CountryFlag";
export default {
  components: {
    // MonthOptions,
    CountryFlag,
  },
  mixins: [InteractsWithQueryString],

  data() {
    return {
      incomes: new window.PaginatedRemoteCollection(
        "/admin/api/magazine/reports"
      ).load()
    };
  },

  methods: {
    load() {
      this.incomes.with(this.$route.query, true).load();
    },

    replace(time) {
      if (this.$route.query.month !== time.month) {
        this.replaceQuery('month', time.month);
      }

      if (this.$route.query.year !== time.year) {
        this.replaceQuery('year', time.year);
      }

      this.replaceQuery('payment', 'appstore');
    },

    calculate() {
      this.$http
        .post(`/admin/api/magazine/calculate/income`, {
          'month': this.$route.query.month,
          'year': this.$route.query.year
        }).then(() => {
        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully changed."
        });
      });
    },

    appleData() {
      this.$http
        .post(`/admin/api/magazine/transfer/income/apple`).then(() => {

        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully changed."
        });

        this.incomes.load();
      });
    },

    dataRecorded(message) {
      console.log(message)
      this.$buefy.toast.open({
        type: "is-success",
        message: message.message
      });
    },
  },

  computed: {
    dateRange() {
      return this.$route.query.month + " / " + this.$route.query.year;
    },
  },
};
</script>
